<template>
  <fieldset class="space-y-2">
    <div
      v-for="leg in props.legs"
      :key="leg.id"
      class="relative flex items-start"
    >
      <div class="flex h-5 items-center">
        <CheckboxGroup
          v-model="localValue"
          :value="leg.id"
          :id="`leg-${leg.id}`"
        />
      </div>
      <div class="ml-3">
        <LabelBase :for="`leg-${leg.id}`"
          >{{ leg.departure_airport.display_code }} to
          {{ leg.arrival_airport.display_code }}</LabelBase
        >
        <ParagraphText size="text-xs" color="text-gray-500">{{
          leg.formatted_departure_date
        }}</ParagraphText>
      </div>
    </div>
  </fieldset>
  <InputError :message="props.error" />
</template>

<script setup>
import CheckboxGroup from '@/Common/Forms/Checkboxes/CheckboxGroup.vue'
import LabelBase from '@/Common/Forms/LabelBase.vue'
import InputError from '@/Common/Forms/Inputs/InputError.vue'
import ParagraphText from '@/Common/Text/ParagraphText.vue'
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
  legs: {
    type: Array,
    required: true,
  },
  error: String,
})

const emit = defineEmits(['update:modelValue'])

const localValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  },
})
</script>
